<template>
    <div>
		<div class="maxContainer economicCalendar internalecomiccal">
			<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
	      	<div class="mainTitle text-center my-3">
	          <h3 class="mb-2"> {{ $t('EconomicCalendar') }}</h3>
	          <!--<p class="mb-4">{{ $t('ecoCalMsz') }} </p>-->
	        </div>  

	        <div class="whiteBG ecoCalendarTable pt-3 border supportpagetab radius mb-3" v-if="!load_more_msz"> 
	        	<div class="d-flex justify-content-between border-bottom pb-3 px-3 mb-2" v-if="economicCalData != ''">
	        		<div></div>
	 				<filter-component :limitFilter="'disable'" :searchFilter="'disable'"  :pageTitle="pageName"></filter-component>
				</div>
					<div class="tablePmm table-responsive"  >
						<table class="table impactValue">
							<thead>
								<tr>
									<!-- <th>Category</th> -->
									<th> {{$t('Time')}}</th>
									<th>{{ $t('Country') }} </th>
									<th>{{ $t('Event') }} </th>
									<th>{{ $t('Importance') }} </th>
									<th>{{ $t('Actual') }} </th>
									<th>{{ $t('Previous') }} </th>
									<!-- <th>{{ $t('currency') }} </th> -->
									<th>{{ $t('Forecast') }}</th>
									<!--<th>{{ $t('Revised') }} </th> 
									 <th>Source</th> -->
									<!-- <th>{{ $t('symbol') }} </th> -->
									<!-- <th>{{ $t('TEForecast') }} </th> -->
									
								</tr>
							</thead>
							<tbody v-if="economicCalData != '' && !pageLoader" v-for="list, key in economicCalData" >
								<tr class="fxs_c_period">
									 <td colspan='7'>{{key | moment("dddd, DD MMMM YYYY")}}</td>
								</tr>
								<tr v-for="calenderDatewise in list">

									<td class="nowrap">{{Getdate(calenderDatewise.Date,offset)}}</td>
									<!-- <td v-html="(list.Category != '' && list.Category != null)?list.Category : '-'"></td> -->
									<td class="d-flex align-items=center">
										<img :src="'../../../../static/fxView/images/country_images/'+calenderDatewise.Country.toLowerCase()+'.svg'"  class="data_currency_icon" /> {{calenderDatewise.Country}}
									</td>
									<td v-html="(calenderDatewise.Event != '' && calenderDatewise.Event != null)?calenderDatewise.Event : '-'"></td>
									
									<td><feather type="bar-chart" class="inColor" :class= "priorityLabel[calenderDatewise.Importance]"></feather></td>

									
									<td v-html="(calenderDatewise.Actual != '' && calenderDatewise.Actual != null)?calenderDatewise.Actual : '-'"></td>

									<td v-html="(calenderDatewise.Previous != '' && calenderDatewise.Previous != null)?calenderDatewise.Previous : '-'"></td>

									<td v-html="(calenderDatewise.Forecast != '' && calenderDatewise.Forecast != null)?calenderDatewise.Forecast : '-'"></td>
									<!--<td v-html="(list.Revised != '' && list.Revised != null)?list.Revised : '-'"></td>-->
									<!-- <td v-html="(list.Source != '' && list.Source != null)?list.Source : '-'"></td> -->
									<!-- <td v-html="(list.Symbol != '' && list.Symbol != null)?list.Symbol : '-'"></td> -->
									<!-- <td v-html="(list.TEForecast != '' && list.TEForecast != null)?list.TEForecast : '-'"></td> -->
									
								</tr>
							</tbody>
							<tbody v-else>
								<tr class="customtableloading" v-for="n in 7">
									<td class="animated-background"  v-for="i in 7"> 
										<div class="animated-background"></div>
									</td>
								</tr>
							</tbody>
						</table>  
					</div>
				 
			</div>  
			<!--<p v-if="pageLoader && economicCalData != ''">loading data....</p>-->		
			<div class="whiteBG border radiusbold p-5 mb-3 justify-content-between align-items-center d-flex" v-if="load_more_msz">
				<img src="../../../../static/fxView/images/manworking.svg" alt="live account" width="400" class="mr-5">
				<div class="lft">
					<h3 class="mb-4" v-html="$t('reachFreeLimit')"></h3> 
					<span><router-link class="prism_btn btn_sm" to="/create-live-account">{{$t('CreateLiveAccount')}}</router-link></span> 
					<span><a href="#" class="prism_btn btn_sm darkBG ml-2" @click="load_more_msz = false">{{$t('Cancel')}}</a></span> 
				</div> 
			</div>  
			<div class="text-center pt-3 mb-3">
				<a href="#" class="prism_btn btn_sm mb-3" @click="load_more_msz = true"  v-if="parseInt(tradingAccountList.totalLiveAccounts) == 0 && !load_more_msz">{{$t('LoadMore')}}</a>
				<a href="#" class="prism_btn btn_sm mb-3" @click="loadList()" v-else-if="parseInt(tradingAccountList.totalLiveAccounts) > 0">{{$t('LoadMore')}}</a>
				<p> {{ $t('Poweredby') }} <a href="https://portfolios.com/" target="_blank"> {{ $t('PortfoliosCom') }}</a></p>
			</div> 
		</div>
		<div class="mb-2 text-center disclaimer darkBG p-3 row d-flex justify-content-center align-items-center">
			<div class="col-12 col-md-10 p-0">
				<small>{{$t('DisclaimerAutoChartist')}}</small>
			</div>
		</div>
    </div>
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	import moment from 'moment'
	export default {
		name: 'Economic-Calender',
		mixins: [fxViewMixins],
		data() {
			return {
				pageName : this.$options.name,
				load_more_msz : false,
				//===========prop in loader component=======
				col_span : 5,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				loaderFuncRun : '1',
				fromDateField : '',
				toDateField : '',
				priority : '1',
				//==========================================
				pageLimit : '15',
				search : '',
				page : 1,
				priorityLabel: {"1": "yellow", "2": "orange", "3": "red"},
				offset : ''
			}
		},
		methods:{
			countryName(getData){
				if(getData != '' && getData != null){
					
				}else{
					return '-';
				}
			},
			loadList(){
				
				this.page = parseInt(this.page) + 1
				this.listing()
			},
			Getdate(key,offset){
			    if(offset == ''){
			        return moment(key).format("hh:mm a")
			    }else{
			        let d = new Date(key);
			        let utc = d.getTime() + (d.getTimezoneOffset() * 60000);
			        let nd = new Date(utc + (3600000*offset));
			        return moment(nd).format("hh:mm a")
			    }
 			},
			listing(){
				let inputJson = {
					'globalParams' : {
						filter: {'from':this.fromDateField ,'to':this.toDateField,'priority':this.priority },
						sort: [],
						search: this.search,
						page: this.page,
						perPage: parseInt(this.pageLimit),
						offset : (new Date().getTimezoneOffset())
					} ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
				}
				this._runGetEconomicCalData(inputJson)
			}
		},
		created(){
			if(this.$store.getters[Const.GET_ECONOMIC_CALENDER_DATA] != ''){
				this.loaderFuncRun = '0'
			}
			this.listing()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/economic-calendar.vue